import { Button, Modal } from '@cfs-fixings/shared'

type PropTypes = {
  isOpen: boolean,
  onClose: () => void,
  onConfirm: () => void,
  title: React.ReactNode,
  message: string
  isLoading: boolean
  confirmButtonText?: string
}

const DeleteModal = ({ isOpen, onClose, onConfirm, title, message, isLoading, confirmButtonText = 'Confirm Deletion' }: PropTypes) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<div className="flex items-center gap-2">
        {title}
      </div>}
      size="md"
      content={
        <div className="flex flex-col gap-6">
          <div className="text-start text-sm mr-7 text-gray-650">{message}</div>
          <div className="flex gap-3 justify-end w-full">
            <Button
              variant="outline"
              onClick={onClose}
              isDisabled={isLoading}
            >
                Cancel
            </Button>
            <Button
              onClick={() => {
                onConfirm()
              }}
              isLoading={isLoading}
              variant={'danger'}
            >
              {confirmButtonText}
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default DeleteModal
